import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { pageStyles } from "./pageStyles";
import NavBar from "./NavBar";

function ChangePasswordForm() {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setDone(false);
    if (next.length < 8) return setError("New password must be at least 8 characters.");
    if (next !== confirm) return setError("The two new passwords do not match.");
    setBusy(true);
    try {
      await changePassword(current, next);
      setCurrent("");
      setNext("");
      setConfirm("");
      setDone(true);
    } catch (err) {
      setError(err.message || "Could not change the password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} style={{ marginTop: "28px", borderTop: "1px solid #17191d", paddingTop: "6px" }}>
      <h2 style={{ ...pageStyles.title, fontSize: "1.1rem", marginTop: "14px" }}>Change password</h2>
      <p style={pageStyles.subtitle}>Got a temporary password from the site owner? Set your own here.</p>

      <label style={pageStyles.label} htmlFor="cp-current">Current password</label>
      <input id="cp-current" type="password" required autoComplete="current-password"
        value={current} onChange={(e) => setCurrent(e.target.value)} style={pageStyles.input} />

      <label style={pageStyles.label} htmlFor="cp-new">New password</label>
      <input id="cp-new" type="password" required minLength={8} autoComplete="new-password"
        value={next} onChange={(e) => setNext(e.target.value)} style={pageStyles.input} />

      <label style={pageStyles.label} htmlFor="cp-confirm">Confirm new password</label>
      <input id="cp-confirm" type="password" required minLength={8} autoComplete="new-password"
        value={confirm} onChange={(e) => setConfirm(e.target.value)} style={pageStyles.input} />

      {error ? <div style={pageStyles.errorBanner}>{error}</div> : null}
      {done ? <div style={pageStyles.successBanner}>Password changed. Other devices were signed out.</div> : null}

      <button type="submit" disabled={busy}
        style={{ ...pageStyles.button, ...(busy ? pageStyles.buttonDisabled : {}) }}>
        {busy ? "Saving…" : "Change password"}
      </button>
    </form>
  );
}

export default function ProfilePage() {
  const { user } = useAuth();

  return (
    <div style={pageStyles.page}>
      <NavBar />
      <div style={pageStyles.authWrap}>
        <div style={pageStyles.card}>
          <h1 style={pageStyles.title}>Account</h1>
          <p style={pageStyles.subtitle}>{user?.is_guest ? "One-hour guest access. Create an account to keep your workspace after this session expires." : "Your account details."}</p>

          <label style={pageStyles.label}>Name</label>
          <div style={pageStyles.input}>{user?.display_name || "—"}</div>

          {!user?.is_guest && <><label style={pageStyles.label}>Email</label><div style={pageStyles.input}>{user?.email}</div></>}

          <label style={pageStyles.label}>Member since</label>
          <div style={pageStyles.input}>
            {user?.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}
          </div>

          {user?.is_guest ? <><label style={pageStyles.label}>Trial ends</label><div style={pageStyles.input}>{user.guest_expires_at ? new Date(user.guest_expires_at).toLocaleString() : "1 hour after starting"}</div><Link to="/signup" style={{ ...pageStyles.button, display: "grid", placeItems: "center", boxSizing: "border-box", textDecoration: "none" }}>Create an account</Link></> : user?.id !== "local" ? <ChangePasswordForm /> : null}

          <div style={pageStyles.linkRow}>
            <Link to="/app" style={pageStyles.link}>Back to chart</Link>
            <span />
          </div>
        </div>
      </div>
    </div>
  );
}
